<template>
  <div
    v-if="!loading && !error"
    class="fou-dashboard-merchendising-tips"
    data-qa-id="merchendising-tips-container"
  >
    <div class="fou-dashboard-merchendising-tips__featured">
      <h2
        data-qa-id="merchendising-tips-content-title"
        class="fou-dashboard-merchendising-tips__featured__title"
      >
        {{ contentTitle }}
      </h2>
      <p
        data-qa-id="merchendising-tips-p"
        class="fou-dashboard-merchendising-tips__featured__para"
        v-html="$sanitize(content.description)"
      />
      <div
        v-if="content.image"
        data-qa-id="merchendising-tips-image"
      >
        <img
          class="image-right-sidebar"
          :src="bgImage"
          alt="Merchandising Tips"
        />
      </div>

      <MdButton :data-qa-id="learnMoreDataQaId"
        :disabled="!ufda2Status">
        <a :href="contentUrl(content.cta.ctaLink)" :target="anchorTarget" :class="'readmore-btn'">
          {{ content.cta.ctaText }}
        </a>
      </MdButton>
    </div>
  </div>
</template>

<script src="./script.js"></script>
